var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticClass:"el-header",attrs:{"height":"auto"}},[_c('home-header')],1),_c('el-main',{staticClass:"el-main"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('el-footer',{staticClass:"el-footer",attrs:{"height":"auto"}},[_c('page-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }